import { eEstadoMaestro } from "../common/enumModel";
import { IFilterGbuModel } from "../interfaces/gbus/IFilterGbuModel";

export class FilterGbuModel implements IFilterGbuModel {    
    idGbu: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idGbu = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}